import { Capacitor } from '@capacitor/core';
import { usePrivy } from '@privy-io/react-auth';
import { useNavigate } from 'react-router-dom';
import { EVENT_LOGIN_BUTTON_CLICKED, sendEvent } from '../common/analytics';

const useCustomLogin = () => {
  const { login } = usePrivy();

  const navigate = useNavigate();

  return {
    login: Capacitor.isNativePlatform()
      ? () => navigate('/')
      : (parameters) => {
          sendEvent(EVENT_LOGIN_BUTTON_CLICKED);
          login(parameters);
        },
  };
};

export default useCustomLogin;
